export default __webpack_public_path__ + "506b92a64f1c974524c379df00ffc850.png";